import React, {useState} from "react";
import { BottomScrollListener } from "react-bottom-scroll-listener";
import BlueprintImageFullDetails from "./BlueprintImageFullDetails";
import I18n from 'i18n.js.erb'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import {
  CURRENCY_EURO,
  parseAmount,
  parseGradeOverall
} from "../../utils/utils";
import EncasingParser from "./EncasingParser";
import BlueprintImageAccordionContent from "./BlueprintImageAccordionContent";
import {
  BlueprintImageAccordionTitleIcon,
  BlueprintImageAccordionTitleImage,
  BlueprintImageAccordionTitleName
} from "./BlueprintImageAccordionTitle";
import LanguageFlag from "./LanguageFlag";
import GradingCertificate from "./GradingCertificate";

const CartContent = ({
  loading,
  cartItems,
  getCartItems,
  hasLoadedAllCartItems,
  handleShowLargeImage,
  showPopupToDeleteItem,
  isBusinessAccount
}) => {

  const [blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage] = useState(null)
  const [productToShowGradingCertificate, setProductToShowGradingCertificate] = useState(null)
  const [showCertificate, setShowCertificate] = useState(false)
  
  return (
    <React.Fragment>
      <div className="w-90 m-auto mt-10px">
        {
          loading ?
            <div className="d-flex justify-content-center mt-5">
              <div className="d-flex align-items-center text-muted">
                <div className="spinner-border" role="status" />
                <b className="ml-2">{I18n.t('js.common.loading')}</b>
              </div>
            </div>
            :
            cartItems.length > 0 ?
              <BottomScrollListener onBottom={getCartItems}>
                <div className="d-none d-lg-block table-responsive">
                  <table id="cart-edit" className="table table-hover bg-white">
                    <thead className="thead-dark">
                    <tr>
                      <th className="text-center">{I18n.t('js.editCartPage.tableHeaderProduct')}</th>
                      <th className="text-center">{I18n.t('js.editCartPage.tableHeaderEncasing')}</th>
                      <th className="text-center">{I18n.t('js.editCartPage.tableHeaderLabelLanguage')}</th>
                      {
                        isBusinessAccount &&
                        <th className="text-center">{I18n.t('js.editCartPage.tableHeaderCondition')}</th>
                      }
                      <th className="text-center">{I18n.t('js.editCartPage.tableHeaderGrading')}</th>
                      <th className="text-center">{I18n.t('js.editCartPage.tableHeaderErrors')}</th>
                      <th className="text-center">{I18n.t('js.editCartPage.tableHeaderPrice')}</th>
                      <th className="text-center" />
                    </tr>
                    </thead>
                    <tbody>
                    {cartItems.map((item, i) =>
                      <tr key={item.id} id={item.id}
                          className={item.product.is_graded && item.product.current_grading && item.product.current_grading.is_valid && item.product.current_grading.serial_number ? 'cursor-pointer' : ''}
                          onClick={() => item.product.is_graded && item.product.current_grading && item.product.current_grading.is_valid && item.product.current_grading.serial_number ? window.location = `/grading_certificate/${item.product.current_grading.serial_number}` : {}}
                      >
                        <td className="text-left minW-450px">
                          <BlueprintImageFullDetails
                            blueprintImage={item.product.blueprint_image}
                            handleShowLargeImage={(e) => handleShowLargeImage(e, item.product.blueprint_image)}
                            defaultCursor={'auto'}
                          />
                        </td>
                        <td className="text-center">
                          {
                            item.product.current_grading &&
                              <p className="text--size-18px text-capitalize">
                                <EncasingParser
                                  encasing={item.product.current_grading.encasing}
                                  categoryName={item.product.blueprint_image.blueprint.category.name}
                                />
                              </p>
                          }
                        </td>
                        <td className="text-center">
                          {
                            item.product.current_grading &&
                              <div className="text--size-18px">
                                <LanguageFlag
                                  language={item.product.current_grading.label_language}
                                  containerCssClassList={'d-flex justify-content-center'}
                                />
                              </div>
                          }
                        </td>
                        {
                          isBusinessAccount &&
                          <td className="text-center">
                            <p className="text--size-18px text-capitalize">{item.product.condition}</p>
                          </td>
                        }
                        <td id={"grade_overall_" + item.product.id} className="text-center">
                          {
                            item.product.current_grading &&
                            <React.Fragment>
                              <p className="text-weight-700 mt-0" style={{ color: 'green' }}>
                                {parseGradeOverall(item.product.current_grading)}
                              </p>
                              <small>({ item.product.current_grading.serial_number })</small>

                              {
                                item.product.is_graded && item.product.current_grading.is_valid &&
                                <p>
                                  <button type="button"
                                          id="aig-certificate"
                                          className="mt-10px btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-inside-table text--white-space-no-wrap"
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setBlueprintImage2ShowLargeImage(item.product.blueprint_image)
                                            setProductToShowGradingCertificate(item.product)
                                            setShowCertificate(true)
                                          }}
                                  >
                                    <i className="fas fa-award" />
                                    &nbsp; {I18n.t('js.showCertificateModal.certificate')}
                                  </button>
                                </p>
                              }
                            </React.Fragment>
                          }
                        </td>

                        <td className="text-center">
                          {
                            item.product.current_grading?.qualifier &&
                            item.product.current_grading.qualifier !== "none" ?
                              <p className="text--size-18px text-capitalize">{item.product.current_grading.qualifier.replaceAll('_', ' ')}</p>
                              :
                              <p className="text--size-18px">{I18n.t('js.editCartPage.none')}</p>

                          }
                        </td>
                        <td id={"price_" + item.product.id} className="text-center max-w-200px">
                          {item.available_for_sale ?
                            <p className="text--size-18px">{parseAmount(item.product.price) + CURRENCY_EURO} </p>
                            :
                            <React.Fragment>
                              <p className="text-center text--size-18px" style={{ color: 'red' }}>
                                <i className="fas fa-exclamation-triangle fa-lg"/>
                              </p>
                              <p className="text-center text--size-18px" style={{ color: 'red' }}>
                                {I18n.t('js.editCartPage.noAvilableForSale')}
                              </p>
                            </React.Fragment>

                          }
                        </td>
                        <td className="text-center">
                          <button
                            type="button"
                            className="btn m-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              showPopupToDeleteItem(item.id, item.product.price, item.available_for_sale);
                            }}
                          >
                            <i className="fas fa-fw fa-trash fa-lg" />
                          </button>
                        </td>
                      </tr>
                    )}
                    </tbody>
                  </table>
                </div>

              <div className="show-on-mobile-d-block mt-30px">
                {cartItems.map((item, i) => {
                  return (
                    <Accordion defaultActiveKey={cartItems[0].id} className="w-100 mb-3 border-aiG-black-imp br-8px" key={item.id}>
                      <Card className="bg-white border-none border-round-standard">
                        <Accordion.Toggle as={Card.Header} eventKey={item.id}>
                          <div className="row">
                            <BlueprintImageAccordionTitleImage
                              blueprintImage={item.product.blueprint_image}
                              handleShowLargeImage={(e) => handleShowLargeImage(e, item.product.blueprint_image)}
                            />

                            <BlueprintImageAccordionTitleName
                              blueprintImage={item.product.blueprint_image}
                            />

                            <div className="col-3 d-block align-items-center text-center p-0">
                              <BlueprintImageAccordionTitleIcon
                                blueprintImage={item.product.blueprint_image}
                              />

                              {item.available_for_sale ?
                                <p
                                  className="text-left text--size-18px">{parseAmount(item.product.price) + CURRENCY_EURO} </p>
                                :
                                <React.Fragment>
                                  <p className="text-center text--size-18px w-100" style={{ color: "red" }}>
                                    <i className="fas fa-exclamation-triangle fa-lg" />
                                  </p>
                                  <p className="text-center d-none d-md-block ml-2"
                                     style={{ color: "red" }}>{I18n.t("js.editCartPage.noAvilableForSale")}</p>
                                </React.Fragment>

                              }
                            </div>
                          </div>
                        </Accordion.Toggle>

                        <Accordion.Collapse eventKey={item.id}>
                          <div className="row mt-10px pb-3">
                            <div className="col-12">

                              <BlueprintImageAccordionContent
                                blueprintImage={item.product.blueprint_image}
                                isProduct={true}
                              />

                              {
                                item.product.current_grading &&
                                  <div className="row">
                                    <div className="col-xs-3 col-md-2 mt-2 mt-md-0">
                                      <p
                                        className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.encasing")}:</p>
                                    </div>

                                    <div className="col-xs-9 col-md-4">
                                      <p className="pr-20px text-right text-md-left pl-md-2 mb-0 text-capitalize">
                                        <EncasingParser
                                          encasing={item.product.current_grading.encasing}
                                          categoryName={item.product.blueprint_image.blueprint.category.name}
                                        />
                                      </p>
                                    </div>

                                    <div className="col-xs-3 col-md-2 mt-2 mt-md-0">
                                      <p
                                        className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.labelLanguage")}:</p>
                                    </div>

                                    <div className="col-xs-9 col-md-4">
                                      <div className="pr-20px text-right text-md-left pl-md-5 mb-0 text-capitalize">
                                        <LanguageFlag
                                          language={item.product.current_grading.label_language}
                                          containerCssClassList={'d-flex justify-content-end'}
                                        />
                                      </div>
                                    </div>
                                  </div>
                              }


                              <div className="row">
                                {
                                  isBusinessAccount &&
                                  <React.Fragment>
                                    <div className="col-xs-3 col-md-2 mt-2 mt-md-0">
                                      <p
                                        className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.condition")}:</p>
                                    </div>

                                    <div className="col-xs-9 col-md-4">
                                      <p
                                        className="pr-20px text-right text-md-left pl-md-2 mb-0 text-capitalize">{item.product.condition}</p>
                                    </div>
                                  </React.Fragment>
                                }

                                {
                                  item.product.current_grading &&
                                    <React.Fragment>
                                      <div className="col-xs-3 col-md-2 mt-2 mt-md-0">
                                        <p
                                          className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.cardGrading")}:</p>
                                      </div>

                                      <div className="col-xs-9 col-md-4 mt-2 mt-md-0">
                                        <div className="pr-20px text-right text-md-left pl-md-2 mb-3">
                                          <p className="mb-2 text-weight-700" style={{ color: "green" }}>
                                            {parseGradeOverall(item.product.current_grading)}
                                          </p>
                                          <small>({item.product.current_grading.serial_number})</small>

                                          {
                                            item.product.is_graded && item.product.current_grading.is_valid &&
                                            <div>
                                              <div className="col-9 px-0 py-1">
                                                <button type="button"
                                                        id="aig-certificate"
                                                        className="mt-10px btn-standard bg-dark text-light pr-2 pl-2 btn-standard-resized pt-4px-imp h-auto btn-inside-table text--white-space-no-wrap"
                                                        onClick={(e) => {
                                                          e.stopPropagation();
                                                          setBlueprintImage2ShowLargeImage(item.product.blueprint_image);
                                                          setProductToShowGradingCertificate(item.product);
                                                          setShowCertificate(true);
                                                        }}
                                                >
                                                  <i className="fas fa-award" />
                                                  &nbsp; {I18n.t("js.showCertificateModal.certificate")}
                                                </button>
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </React.Fragment>
                                }
                              </div>

                              <div className="row">
                                {

                                  item.product.current_grading?.qualifier &&
                                  item.product.current_grading.qualifier !== "none" &&
                                    <React.Fragment>
                                      <div className="col-xs-7 col-md-2 mt-2 mt-md-0">
                                        <p
                                          className="pl-20px text-weight-500">{I18n.t("js.editCartPage.tableHeaderErrors")}:</p>
                                      </div>

                                      <div className="col-xs-5 col-md-4 mt-2 mt-md-0">
                                        <p
                                          className="pr-20px text-right text-md-left pl-md-2 mb-0 text-capitalize">{item.product.current_grading.qualifier.replaceAll("_", " ")}</p>
                                      </div>
                                    </React.Fragment>
                                }

                                <div className="col-xs-3 col-md-2 mt-2 mt-md-0">
                                  <p
                                    className="pl-20px text-weight-500 text--white-space-no-wrap">{I18n.t("js.filters.sort.cardPrice")}:</p>
                                </div>

                                <div className="col-xs-9 col-md-4 mt-2 mt-md-0">
                                  {item.available_for_sale ?
                                    <p
                                      className="pr-20px text-right text-md-left pl-md-2 mb-0">{parseAmount(item.product.price) + CURRENCY_EURO} </p>
                                    :
                                    <p className="pr-20px text-right text-md-left pl-md-2 mb-0"
                                       style={{ color: "red" }}>{I18n.t("js.editCartPage.noAvilableForSale")}</p>
                                  }
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-xs-3 col-md-2 mt-2 mt-md-0">
                                  <p className="pl-20px text-weight-500 text--white-space-no-wrap" />
                                </div>

                                <div className="col-xs-9 col-md-4 text-right text-md-left pl-md-5">
                                  <button
                                    type="button"
                                    className="btn m-2 mt-md-0 pt-md-0"
                                    onClick={() =>
                                      showPopupToDeleteItem(item.id, item.product.price, item.available_for_sale)
                                    }
                                  >
                                    <i className="fas fa-fw fa-trash fa-lg" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  );
                })}
                </div>

                {
                  !hasLoadedAllCartItems && cartItems.length > 0 &&
                  <div className="d-flex justify-content-center mt-5">
                    <div className="d-flex align-items-center text-muted">
                      <div className="spinner-border" role="status" />
                      <b className="ml-2">{I18n.t('js.common.loading')}</b>
                    </div>
                  </div>
                }

              </BottomScrollListener>
              :
              <div className="d-flex justify-content-center mt-5 pt-5">
                <div className="d-flex align-items-center text-muted">
                  <p className="text-center text--size-18px text-weight-700">{I18n.t('js.editCartPage.emptyCart')}</p>
                </div>
              </div>
        }
      </div>

      <GradingCertificate
        originalGradingCertificate={productToShowGradingCertificate ? productToShowGradingCertificate.current_grading : ''}
        originalBlueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate}
      />

    </React.Fragment>
  );
};

export default CartContent;